import { cachedDateFormat } from '@/lib/dateLocale';

/**
 * ISO day → "13 Oct 2026" / "13. okt. 2026". The shared `formatShortDate`
 * drops the year, which a project frame (and decision 11's "Since …") needs.
 * A calendar day, so formatted in UTC.
 */
const settingsDateFormat = cachedDateFormat({
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
});

export const formatSettingsDate = (iso: string): string => {
  const parsed = Date.parse(iso);
  return Number.isNaN(parsed) ? '' : settingsDateFormat().format(parsed);
};
